import { atom } from "recoil";

export const applicationProgressState = atom<number>({
  key: "applicationProgressState",
  default: 0,
});
